<template>
  <PageLayout class="pets-page">
    <div class="pets-page__title-block">
      <div class="pets-page__title">
        <PageTitle>Оформлення страховки від {{ getOfferCompanyName }}</PageTitle>
        <Breadcrumbs
          class="pets-page__breadcrumbs"
          :breadcrumbs="getBreadcrumbs"
        />
      </div>
      <div class="pets-page__back">
        <SmartLink
          class="pets-page__back-link"
          @click="$router.push({ name: 'petsOffers', query: getCalculationQueryParams })"
        >
          <OpenDownIcon color="#0A77FF" class="pets-page__back-link__icon" />
          Повернутися до вибору пропозицій
        </SmartLink>
      </div>
    </div>
    <PetsPolicyDetails />
  </PageLayout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { pages } from '@/entities/current-page';
import { PetsPolicyDetails } from '@/features/pets-policy-details';
import {
  ContractState,
  DocumentState,
  OfferState,
  PetsPolicyholderState,
} from '@/shared/lib/insurance';
import { PetsCalculateParams } from '@/shared/lib/insurance/offer';
import { Breadcrumbs } from '@/shared/ui/breadcrumbs';
import { OpenDownIcon } from '@/shared/ui/icons';
import { PageLayout } from '@/shared/ui/layouts';
import { SmartLink } from '@/shared/ui/link';
import { PageTitle } from '@/shared/ui/page-title';

const { preparePetsCalculationQueryParams } = PetsCalculateParams();

export default {
  created() {
    this.changeActivePage(pages.PRODUCTS_AND_PROPOSITIONS);
  },
  mixins: [
    PetsPolicyholderState('petsModule'),
    ContractState('petsModule'),
    DocumentState('petsModule'),
    OfferState('petsModule'),
  ],
  components: { PageTitle, Breadcrumbs, PageLayout, SmartLink, OpenDownIcon, PetsPolicyDetails },
  computed: {
    ...mapGetters('petsModule', ['getOffer', 'getCalculatorEarnings']),
    getBreadcrumbs() {
      return [
        {
          title: 'Панель управління',
          url: '#',
        },
        {
          title: 'Страхування тварин',
          url: '#',
        },
        {
          title: 'Пропозиції від СК',
          url: '#',
        },
        {
          title: 'Оформлення страхової',
          url: '#',
        },
      ];
    },
    getOfferCompanyName() {
      return this.getOffer?.company?.name || '';
    },
    getCalculationQueryParams() {
      return preparePetsCalculationQueryParams({
        startFrom: this.contract.startDate,
        insurancePeriod: this.contract.estimatedPeriod,
        earnings: this.getCalculatorEarnings,
      });
    },
  },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
  },
};
</script>

<style lang="scss" scoped>
.pets-page {
  font-family: 'Geist', sans-serif;
  font-size: 14px;
  color: #09090B;

  &__title-block {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin-bottom: 24px;
  }

  &__title {
    margin-bottom: 16px;
  }

  &__breadcrumbs {
    margin-bottom: 0;
  }

  &__back-link {
    display: flex;
    align-items: center;
    font-family: 'Geist', sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: #0A77FF;
    margin-right: 4px;
    cursor: pointer !important;

    &__icon {
      transform: rotate(90deg);
    }
  }
}

::v-deep .breadcrumbs {
  margin-bottom: 0 !important;
}
</style>